import { IRollingCharacter } from "@/helpers/money/types"

const DIGIT = /^[0-9]$/

/** Digits align from the right; `fromChar` is the digit rolled away, `""` for a new leading digit, `null` when nothing rolls. */
export const buildRollingCharacters = (
  previousText: string | null,
  nextText: string
): IRollingCharacter[] => {
  const next = Array.from(nextText)
  if (previousText === null) {
    return next.map((char) => ({ char, fromChar: null }))
  }
  const previous = Array.from(previousText)
  const offset = previous.length - next.length
  return next.map((char, index) => {
    if (!DIGIT.test(char)) {
      return { char, fromChar: null }
    }
    const before = previous[index + offset]
    if (before === undefined) {
      return { char, fromChar: "" }
    }
    return { char, fromChar: before === char ? null : before }
  })
}
